import { ReactNode, useState } from "react";
import { Flex } from "@mantine/core";


interface SidebarTriggerProps {
  target: ReactNode;
  body: ReactNode;
}

export const SidebarTrigger = ({ body, target }: SidebarTriggerProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div onClick={() => {
        setIsOpen(true);
      }}>
        {target}
      </div>
      {isOpen && body && (
        <Flex
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(420px, -50%)',
            zIndex: 1
          }}
        >
          <Flex
            direction="column"
            style={{
              width: '300px',
              position: 'relative',
              padding: '18px',
              backgroundColor: 'rgba(32, 32, 32, 1)',
              borderRadius: '8px',
              boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
            }}
          >
            <div
              onClick={() => setIsOpen(false)}
              style={{
                cursor: 'pointer',
                padding: '4px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'absolute',
                top: 10,
                right: 4,
                zIndex: 1
              }}
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 4L4 12" stroke="#BDBDBD" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M4 4L12 12" stroke="#BDBDBD" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            {body}
          </Flex>
        </Flex>
      )}
    </>
  );
}; 